import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { ContentHeaderKey } from "src/app/constants/content-header";
import { USStates } from "src/app/constants/us-states";
import { ChangeRequestAddressModel } from "src/app/models/change-requests";
import { PayrollAddressModel } from "src/app/models/payroll";
import { PayrollService } from "src/app/services/payroll.service";
import { ChangeRequestStatus } from "src/app/constants/change-request";

@Component({
    selector: 'mwp-payroll-address',
    templateUrl: './address.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PayrollAddressComponent implements OnInit {
    public apiUrl = ContentHeaderKey.PayrollAddress;
    public payrollAddressModel: PayrollAddressModel;
    public changeRequestFormModel: ChangeRequestAddressModel;
    public currentChangeRequestAddressModel: ChangeRequestAddressModel;
    public isEditing: boolean;
    
    public usStates = USStates;
    public hasRequestedEdit: boolean;
    public buttonText: string;
    public displayTopRequestButton: boolean;
    public displayPendingOrDeniedRequest: boolean;
    public pendingOrDeniedHeader: string;

    constructor(
        private payrollService: PayrollService,
    ) { }

    ngOnInit(): void {
        this.payrollService.getAddress().subscribe((response: PayrollAddressModel) => {
            this.payrollAddressModel = response;
            this.currentChangeRequestAddressModel = response.currentChangeRequestAddressModel;
            this.buildCurrentChangeRequest(response.currentChangeRequestAddressModel??  new ChangeRequestAddressModel());
        });
    }

    public newChangeRequest() {
        this.changeRequestFormModel = new ChangeRequestAddressModel();
        this.isEditing = !this.isEditing;
    }

    public editChangeRequest() {
        this.changeRequestFormModel = this.currentChangeRequestAddressModel;
        this.isEditing = !this.isEditing;
    }

    public cancelEdit(event: ChangeRequestAddressModel) {
        if (event)
            this.buildCurrentChangeRequest(event);
        this.isEditing = false;
    }

    private buildCurrentChangeRequest(changeRequest: ChangeRequestAddressModel): void {
        this.displayPendingOrDeniedRequest = false;
        this.displayTopRequestButton = true;
        this.pendingOrDeniedHeader = null;
        this.buttonText = "REQUEST TO CHANGE ADDRESS";
        if (changeRequest.id > 0)
            this.currentChangeRequestAddressModel = changeRequest;

        switch(changeRequest.changeRequestStatusID) {
            case ChangeRequestStatus.submitted:
                this.pendingOrDeniedHeader = "Submitted Address Change Request";
                this.buttonText = "UPDATE ADDRESS CHANGE REQUEST"
                this.displayPendingOrDeniedRequest = true;
                break;

            case ChangeRequestStatus.denied:
                this.displayTopRequestButton = false;
                this.pendingOrDeniedHeader = "Denied Address Change Request";
                this.displayPendingOrDeniedRequest = true;
                break;

            default:
                break;
        }   
    }
}
